import React, { useState } from "react";
import "./OwnerDashBoardNavBar.css";
import NavDropdown from "react-bootstrap/NavDropdown";
import { NavLink } from "react-router-dom";

const OwnerDashBoardNavBar = () => {
  return (
    <>
      <div className="dash-navbar">
        <div>
          <NavLink to="/">
            <img
              src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1720704397/afhlogo_zfiv9i.png"
              alt="dashboard-logo"
              className="company-logo"
            />
          </NavLink>
        </div>
        <div className="profile">
          <div>
            <i className="fa-regular fa-bell dashboard-bell"></i>
          </div>

          <div className="profile">
            <div>
              <i class="fa-solid fa-circle-user dashboard-userprofile"></i>
            </div>

            <NavDropdown id="navbarScrollingDropdown" className="drop-down">
              <NavDropdown.Item href="#action3">Home</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action4">Logout</NavDropdown.Item>
            </NavDropdown>
          </div>
        </div>
      </div>
    </>
  );
};

export default OwnerDashBoardNavBar;
